export const DEFAULT_VOCABULARY_TERMS = {
    case: {
        singular: 'case',
        plural: 'cases',
    },
    caseNumber: {
        singular: 'Case Reference',
        plural: 'Case References',
    },
    caseTitle: {
        singular: 'Case Title',
        plural: 'Case Titles',
    },
    caseType: {
        singular: 'case type',
        plural: 'case types',
    },
    courthouse: {
        singular: 'courthouse',
        plural: 'courthouses',
    },
    courtroom: {
        singular: 'courtroom',
        plural: 'courtrooms',
    },
    department: {
        singular: 'department',
        plural: 'departments',
    },
    hearing: {
        singular: 'hearing',
        plural: 'hearings',
    },
    judge: {
        singular: 'judge',
        plural: 'judges',
    },
    seal: {
        singular: 'seal',
        plural: 'seal',
    },
    sealed: {
        singular: 'sealed',
        plural: 'sealed',
    },
    sealing: {
        singular: 'sealing',
        plural: 'sealing',
    },
    unseal: {
        singular: 'unseal',
        plural: 'unseal',
    },
    unsealed: {
        singular: 'unsealed',
        plural: 'unsealed',
    },
    unsealing: {
        singular: 'unsealing',
        plural: 'unsealing',
    },
};
